import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 1.5rem 0;
`;

const TableRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

const TableLabel = styled(Typography).attrs({ styledAs: 'bodySmallSpaceGrotesk' })`
  color: var(--dark-gray);
  min-width: 120px;
  flex-shrink: 0;
`;

const TableValue = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const ValueItem = styled(Typography).attrs({ styledAs: 'bodySmallSpaceGrotesk' })`
  color: var(--black);
`;

const NoFiltersRow = styled(Typography)`
  padding: 24px 0;
  border-top: 1px solid var(--light-border-gray);
  border-bottom: 1px solid var(--light-border-gray);
`;

export type SaveFiltersTableProps = {
  prescriberNames: string[];
  className?: string;
};

/**
 * Custom table component for displaying saved filters in the SaveFiltersModal.
 */
export const SaveFiltersTable = ({ prescriberNames, className }: SaveFiltersTableProps) => {
  console.log('prescriberNames', prescriberNames);
  return (
    <TableContainer className={className}>
      {prescriberNames.length > 0 ? (
        <TableRow>
          <TableLabel>Prescriber</TableLabel>
          <TableValue>
            {prescriberNames.map((name: string) => (
              <ValueItem key={`${name}`}>{name}</ValueItem>
            ))}
          </TableValue>
        </TableRow>
      ) : (
        <NoFiltersRow styledAs="bodySpaceGrotesk" weight={500}>
          No filters are currently set. Would you like to set this as default?
        </NoFiltersRow>
      )}
    </TableContainer>
  );
};

export default SaveFiltersTable;
